import {
  AVAX,
  BASE,
  BCH,
  BSC,
  BTC,
  DOGE,
  ETH,
  GAIA,
  LTC,
  Network,
  SOL,
  THOR,
  TRON,
  XRP,
} from "rujira.js";

const NETWORK_BY_BLOCKCHAIN: Record<string, Network> = {
  "AVAX-C": AVAX,
  AVALANCHE: AVAX,
  ATOM: GAIA,
  BASE,
  BCH,
  BNB: BSC,
  BSC,
  BTC,
  DOGE,
  ETH,
  ETHEREUM: ETH,
  LTC,
  SOL,
  SOLANA: SOL,
  THOR,
  THORCHAIN: THOR,
  TRON,
  XRP,
};

export const banxaNetwork = (blockchain: string): Network | undefined =>
  NETWORK_BY_BLOCKCHAIN[blockchain.trim().toUpperCase()];
